import { useSuspendedUIDelay } from 'hooks/useDelay';
import { Layout } from 'layouts/Layout/Layout';

import { LoadingPage } from './LoadingPage';

export function LoadingPageLoadable() {
  const { pastDelay } = useSuspendedUIDelay();

  if (!pastDelay) return <Layout />;

  return <LoadingPage noDelay />;
}
